import React from 'react';
import Helmet from 'react-helmet';
import Template from './template';

export default class Terms extends React.Component {
  render() {
    const title = 'Terms and Conditions'
    return (
      <Template title={title}>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title}/>
          <meta
            name="description"
            content={`Learn more about our terms & conditions. Sotheby’s International Realty sells exquisite homes in premier locations across the US.`}/>
        </Helmet>

        <div>
          <h3>What You Should Know</h3>
          <p>
            Welcome to the {window.location.hostname} web site (the "Web Site"). The goal of this Web Site is to provide
            you with access to the most comprehensive network of real estate related products/services and related
            links to meet your needs. Please read our Terms of Use (the "Terms") carefully before continuing on
            with your use of this Web Site. These Terms shall govern the use of the Web Site and apply to all
            Internet traffic visiting the Web Site. By accessing or using this Web Site, you agree to the Terms.
            The Terms are meant to protect all of our Web Site visitors and your use of this Web Site signifies
            your agreement with these Terms. IF YOU DO NOT AGREE WITH THESE TERMS, DO NOT USE THIS WEB SITE.
            Sotheby’s International Realty, Inc. reserves the right, in its sole discretion, to modify, alter or
            otherwise update these Terms at any time. Such modifications shall be effective immediately upon
            posting. By using this Web Site after we have posted notice of such modifications, alterations or
            updates you agree to be bound by such revised Terms.
          </p>
          <p>
            In accordance with our goals, this Web Site will permit you to link to many other web sites, that may
            or may not be affiliated with this Web Site and/or Sotheby’s International Realty, Inc., and that may
            have terms of use that differ from, or contain terms in addition to, the terms specified here. Your
            access to such web sites through links provided on this Web Site is governed by the terms of use and
            policies of those sites, not this Web Site.
          </p>
          <br />
          <h3>Privacy</h3>
          <p>
            Registration data and certain
            other information about you are subject to our <a href="/privacy-policy.pdf" target="_blank">Privacy Policy</a>.
            For more information, please review our full Privacy Policy.
          </p>
          <br />
          <h3>Trademarks, Copyrights and Restrictions</h3>
          <p>
            This Web Site is controlled and operated by Sotheby’s International Realty, Inc., 38 East 61st St.,
            NY, NY 10065. All content on this Web Site, including, but not limited to text, images, illustrations,
            audio clips, and video clips, is protected by copyrights, trademarks, service marks, and/or other
            intellectual property rights (which are governed by U.S. and worldwide copyright laws and treaty
            provisions, privacy and publicity laws, and communication regulations and statutes), and are owned
            and/or licensed by Sotheby’s International Realty Affiliates, LLC. or its affiliates, or by third
            party content providers, merchants, sponsors and licensors (collectively "Providers") that have
            licensed their content or the right to market their products and/or services to Sotheby’s
            International Realty, Inc.. Content on this Web Site or any web site owned, operated, licensed or
            controlled by the Providers is solely for your personal, non-commercial use. You may print a copy of
            the content and/or information contained herein for your personal, non-commercial use only, but you
            may not copy, reproduce, republish, upload, post, transmit, distribute, and/or exploit the content or
            information in any way (including by e-mail or other electronic means) for commercial use without the
            prior written consent of Sotheby’s International Realty Affiliates LLC, your modification of the
            content, use of the content on any other web site or networked computer environment, or use of the
            content for any purpose other than personal, non-commercial use, violates the rights of the owners of
            Sotheby’s International Realty, Inc. and/or the Provider copyrights, trademarks or service marks and
            other proprietary rights, and is prohibited. As a condition to your use of this Web Site, you warrant
            to Sotheby’s International Realty, Inc. that you will not use our Web Site for any purpose that is
            unlawful or prohibited by these Terms, including without limitation the posting or transmitting any
            threatening, libelous, defamatory, obscene, scandalous, inflammatory, pornographic, or profane
            material. If you violate any of these Terms, your permission to use our Web Site immediately
            terminates without the necessity of any notice. Sotheby’s International Realty, Inc. retains the right
            to deny access to anyone at its discretion for any reason, including for violation of these Terms. You
            may not use on your web site any trademarks, service marks or copyrighted materials appearing on this
            Web Site, including but not limited to any logos or characters, without the express written consent of
            the owner of the mark or copyright. You may not frame or otherwise incorporate into another web site
            any of the content or other materials on this Web Site without prior written consent of Sotheby’s
            International Realty, Inc..
          </p>
          <br />
          <h3>Prohibited Activities</h3>
          <p>
            You are specifically prohibited from any use of this Web Site, and You agree not to use or permit
            others to use this Web Site, for any of the following: (a) take any action that imposes an
            unreasonable or disproportionately large load on the Web Site’s infrastructure, including but not
            limited to "spam" or other such unsolicited mass e-mailing techniques; (b) disclose to, or share with,
            the assigned confirmation numbers and/or passwords with any unauthorized third parties or using the
            assigned confirmation numbers and/or passwords for any unauthorized purpose; (c) attempt to decipher,
            decompile, disassemble or reverse engineer any of the software or HTML code comprising or in any way
            making up a part of this Web Site; (d) upload, post, emailing or otherwise transmitting any
            information, Content, or proprietary rights that You do not have a right to transmit under any law or
            under contractual or fiduciary relationships; (e) violating any applicable local, state, national or
            international law, including, but not limited to, any regulations having the force of law; and, (f)
            using any robot, spider, intelligent agent, other automatic device, or manual process to search,
            monitor or copy Our Web pages, or the Content without Our prior written permission, provided that
            generally available third party Web browser such as Netscape Navigator® and Microsoft Internet
            Explorer® may be used without such permission.
          </p>
          <br />
          <h3>Links</h3>
          <p>
            This Web Site may contain links to other web sites ("Linked Sites"). The Linked Sites are provided for
            your convenience and information only and, as such, you access them at your own risk. The content of
            any Linked Sites is not under the control of Sotheby’s International Realty, Inc. Sotheby’s
            International Realty, Inc. is not responsible for, and does not endorse, such content, whether or not
            Sotheby’s International Realty, Inc. is affiliated with the owners of such Linked Sites. You may not
            establish a hyperlink to this Web Site or provide any links that state or imply any sponsorship or
            endorsement of your web site by Sotheby’s International Realty, Inc., or its affiliates or Providers.
          </p>
          <br />
          <h3>Disclaimer of Warranties and Liability</h3>
          <p>
            ALL CONTENT ON THIS WEB SITE IS PROVIDED "AS IS" AND WITHOUT WARRANTIES OF ANY KIND EITHER EXPRESS OR IMPLIED.
            OTHER THAN THOSE WARRANTIES WHICH, UNDER THE U.S. LAWS APPLICABLE TO THESE TERMS, ARE IMPLIED BY LAW AND ARE
            INCAPABLE OF EXCLUSION, RESTRICTION, OR MODIFICATION, EACH OF SOTHEBY’S INTERNATIONAL REALTY AFFILIATES, LLC.
            AND SOTHEBY’S INTERNATIONAL REALTY, INC. DISCLAIMS ANY AND ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT
            NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. NEITHER SOTHEBY’S
            INTERNATIONAL REALTY AFFILIATES, LLC., NOR SOTHEBY’S INTERNATIONAL REALTY, INC., NOR THEIR RESPECTIVE
            AFFILIATED OR RELATED ENTITIES, NOR THE PROVIDERS, NOR ANY PERSON INVOLVED IN THE CREATION, PRODUCTION, AND
            DISTRIBUTION OF THIS WEB SITE WARRANT THAT THE FUNCTIONS CONTAINED IN THIS WEB SITE WILL BE UNINTERRUPTED
            OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT THE SERVER THAT MAKES THE CONTENT AVAILABLE WILL BE
            FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. THE CONTENT THAT YOU ACCESS ON THIS WEB SITE IS PROVIDED SOLELY
            FOR YOUR CONVENIENCE AND INFORMATION ONLY. NEITHER SOTHEBY’S INTERNATIONAL REALTY AFFILIATES, LLC. NOR
            SOTHEBY’S INTERNATIONAL REALTY, INC. WARRANTS NOR MAKES ANY REPRESENTATIONS REGARDING THE RESULTS THAT
            MAY BE OBTAINED FROM THE USE OF THIS WEB SITE, OR AS TO THE RELIABILITY, ACCURACY OR CURRENCY OF ANY
            INFORMATION CONTENT, SERVICE AND/OR MERCHANDISE ACQUIRED PURSUANT TO YOUR USE OF THIS WEB SITE. YOU
            EXPRESSLY AGREE THAT USE OF THIS WEB SITE IS AT YOUR SOLE RISK. YOU (AND NOT SOTHEBY’S INTERNATIONAL
            REALTY AFFILIATES, LLC. NOR SOTHEBY’S INTERNATIONAL REALTY, INC.) ASSUME THE ENTIRE COST OF ALL
            NECESSARY SERVICING, REPAIR OR CORRECTION OF YOUR SYSTEM. YOU EXPRESSLY AGREE THAT NEITHER SOTHEBY’S
            INTERNATIONAL REALTY AFFILIATES, LLC., NOR SOTHEBY’S INTERNATIONAL REALTY, INC., NOR THEIR RESPECTIVE
            AFFILIATED OR RELATED ENTITIES (INCLUDING ITS PROVIDERS), NOR ANY OF THEIR RESPECTIVE EMPLOYEES, OR
            AGENTS, NOR ANY PERSON OR ENTITY INVOLVED IN THE CREATION, PRODUCTION AND DISTRIBUTION OF THIS WEB SITE, IS
            RESPONSIBLE OR LIABLE TO ANY PERSON OR ENTITY WHATSOEVER FOR ANY LOSS, DAMAGE (WHETHER ACTUAL, CONSEQUENTIAL,
            PUNITIVE OR OTHERWISE), INJURY, CLAIM, LIABILITY OR OTHER CAUSE OF ANY KIND OR CHARACTER WHATSOEVER BASED UPON
            OR RESULTING FROM THE USE OR ATTEMPTED USE OF THIS WEB SITE OR ANY OTHER LINKED SITE. BY WAY OF EXAMPLE, AND
            WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, SOTHEBY’S INTERNATIONAL REALTY AFFILIATES, LLC. AND SOTHEBY’S
            INTERNATIONAL REALTY, INC. AND RELATED PERSONS AND ENTITIES SHALL NOT BE RESPONSIBLE OR LIABLE FOR ANY CLAIM OR
            DAMAGE ARISING FROM FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION, DELETION, DEFECT, DELAY IN OPERATION,
            COMPUTER VIRUS, THEFT, DESTRUCTION, UNAUTHORIZED ACCESS TO OR ALTERATION OF PERSONAL RECORDS, OR THE RELIANCE UPON
            OR USE OF DATA, INFORMATION, OPINIONS OR OTHER MATERIALS APPEARING ON THIS WEB SITE. YOU EXPRESSLY ACKNOWLEDGE
            AND AGREE THAT NEITHER SOTHEBY’S INTERNATIONAL REALTY AFFILIATES, LLC. NOR SOTHEBY’S INTERNATIONAL REALTY, INC.
            IS LIABLE OR RESPONSIBLE FOR ANY DEFAMATORY, OFFENSIVE OR ILLEGAL CONDUCT OF OTHER SUBSCRIBERS OR THIRD PARTIES.
            SOME JURISDICTIONS MAY NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES.
            IN SUCH JURISDICTIONS, SOTHEBY’S INTERNATIONAL REALTY AFFILIATES, LLC.’S AND SOTHEBY’S INTERNATIONAL REALTY, INC.’S
            LIABILITY IS LIMITED TO THE GREATEST EXTENT PERMITTED BY LAW.
          </p>
          <br />
          <h3>Indemnification</h3>
          <p>
            You agree to indemnify, defend, and hold harmless Sotheby’s International Realty, Inc. and the
            Providers, its and their officers, directors, employees, affiliates, agents, licensors, and suppliers
            from and against all losses, expenses, damages and costs, including reasonable attorneys’ fees,
            resulting from any violation by you of these Terms.
          </p>
          <br />
          <h3>Third Party Rights</h3>
          <p>
            These Terms are for the benefit of Sotheby’s International Realty, Inc. and its Providers, its and
            their officers, directors, employees, affiliates, agents, licensors, and suppliers. Each of these
            individuals or entities shall have the right to assert and enforce these Terms directly against you on
            its or their own behalf.
          </p>
          <br />
          <h3>Jurisdictional Issues</h3>
          <p>
            Unless otherwise specified, the content contained in this Web Site is presented solely for your
            convenience and/or information. This Web Site is controlled and operated by Sotheby’s International
            Realty, Inc. from its offices within New York, New York. Sotheby’s International Realty, Inc. makes no
            representation that content in its Web Site is appropriate or available for use in other locations.
            Those who choose to access this Web Site from other locations do so on their own initiative and are
            responsible for compliance with local laws, if and to the extent local laws are applicable. You may
            not use or export the materials in this Web Site in violation of U.S. export laws and regulations.
            These Terms shall be governed by, construed and enforced in accordance with the laws of the State of
            New Jersey, as they are applied to agreements entered into and to be performed entirely within such
            State. Any action you, any third party or Sotheby’s International Realty Affiliates, LLC. brings to
            enforce these Terms, or in connection with any matters related to this Web Site, shall be brought only
            in either the state or Federal courts located in Newark, New Jersey and you expressly consent to the
            jurisdiction of said courts. If any provision of these Terms shall be unlawful, void or for any reason
            unenforceable, then that provision shall be deemed severable from these Terms and shall not affect the
            validity and enforceability of any remaining provisions.
          </p>
        </div>
      </Template>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/about-us/terms.js